export default __webpack_public_path__ + "static/media/JobSix6.67c650af.jpg";